import React from 'react';
import { Table } from 'antd';
import '../../css/JuanIS/JuanISFacultyClassSchedule.css';

function JuanISFacultyClassSchedule() {
  // Sample data - replace with actual data from your backend
  const scheduleData = [
    {
      key: '1',
      subject: 'Oral Communication',
      section: 'STEM-11A',
      schedule: 'MWF 8:00 AM - 9:00 AM',
      room: 'Room 101',
      students: 35
    },
    {
      key: '2',
      subject: 'General Mathematics',
      section: 'STEM-11B',
      schedule: 'TTH 10:00 AM - 11:30 AM',
      room: 'Room 203',
      students: 32
    }
  ];

  const columns = [
    {
      title: 'Subject',
      dataIndex: 'subject',
      key: 'subject',
    },
    {
      title: 'Section',
      dataIndex: 'section',
      key: 'section',
    },
    {
      title: 'Schedule',
      dataIndex: 'schedule',
      key: 'schedule',
    },
    {
      title: 'Room',
      dataIndex: 'room',
      key: 'room',
    },
    {
      title: 'No. of Students',
      dataIndex: 'students',
      key: 'students',
    }
  ];

  return (
    <div className="juanis-faculty-schedule-container">
      <div className="juanis-faculty-schedule-header">
        <h1>Class Schedule</h1>
        <p>Academic Year 2024-2025, 1st Semester</p>
      </div>
      
      <div className="juanis-faculty-schedule-content">
        <Table 
          dataSource={scheduleData} 
          columns={columns} 
          pagination={false}
          className="juanis-faculty-schedule-table"
          scroll={{ x: 800 }} // Enable horizontal scrolling for smaller screens
        />
      </div>
    </div>
  );
}

export default JuanISFacultyClassSchedule;